import { Injectable } from "@angular/core";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";
import { PlessJsonResponderSub } from "src/app/commons/kymw00/pless-json-responder-sub.service";
import { PlessHttp } from "src/app/shared/http/pless-http.service";
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { KYMW6901MasterInputTabModel } from "../kymw6901-master-input-tab.model";
import { MasterInputModel } from "../vo/master-input.model";
import { KYMW6901Component } from "../../kymw6901.component";

type GetMasterInputResponse = {
  MasterInputId: string;
  PCode: string;
  ItemCode: string;
  JanCode: string;
  GoodsName: string;
  StandardName: string;
  PublishMediumType: string;
  ClassCode: string;
  LargeClassCode: string;
  MiddleClassCode: string;
  SmallClassCode: string;
  OrderUnitType: string;
  SetQuantity: string;
  SuggestedPriceSellingNormal: string;
  SuggestedPriceSellingSpecial1: string;
  SuggestedPriceSellingSpecial2: string;
  SuggestedPricePurchaseNormal: string;
  SuggestedPricePurchaseSpecial1: string;
  SuggestedPricePurchaseSpecial2: string;
  BundlePrice: string;
  UnitPriceDiv: string;
  UnitPriceCoefficient: string;
  UnitPriceUnit: string;
  EdlpDiv: string;
  ConsumeByDate: string;
  ConsumeTerm: string;
  SetDiv: string;
  CaseSupplyDiv: string;
  ArrivalAreaDiv: string;
  ArrivalGoodsTemp: string;
  ArrivalAdminDays: string;
  BrandType: string;
  EcologyDiv: string[];
  CycleTerm: string;
  PriceType: string;
  MakerPrice: string;
  CoopCode: string[];
  PackagePhotographNum: string;
  PackageDataNum: string;
  PeakPhotographNum: string;
  PeakDataNum: string;
  CookingNecessaryPhotoNum: string;
  CookingNecessaryDataNum: string;
  CookingUnnecessaryPhotoNum: string;
  CookingUnnecessaryDataNum: string;
  MaterialPhotographNum: string;
  MaterialDataNum: string;
  BacksidePhotographNum: string;
  BacksideDataNum: string;
  GoodsExplanation: string;
  Catchphrase: string;
  RecommendComment: string;
  UsefulInfoEnclosure: string;
  UsefulInfoConfiguration: string;
  UsefulInfoOther: string;
  UsefulInfoSize: string;
  HandlingCaution: string;
  MarkDiv: string[],
  ConsumeTaxRate: string;
  AlcoholPercentage: string;
  FruitJuice: string;
  SakeMeterValue: string;
  Body: string;
  FunctionalOrFoshu: string;
  LiquorCode: string;
  AlcoholType: string;
  ContainerForm: string;
  ApplyTermStart: string;
  ApplyTermEnd: string;
  SeasonConsumeDiv: string;
  SeasonConsumeTermStart: string;
  SeasonConsumeTermEnd: string;
  StinkGoodsDiv: string;
  ListingGoodsName: string;
  ListingType: string;
  ListingContentsQuantity: string;
  ListingSize: string;
  ListingSizeCm: string;
  ListingNumber: string;
  ListingColor: string;
  PieceSizeLength: string;
  PieceSizeWidth: string;
  PieceSizeHeight: string;
  PieceWeight: string;
  CaseSizeLength: string;
  CaseSizeWidth: string;
  CaseSizeHeight: string;
  CaseWeight: string;
  IngredientInfo: string;
  IngredientsDisp: string;
  RelationPcodeOld: string;
  SpecialOrderType: string;
  StockType: string;
  PdPilingUpDays: string;
  FactoryAddress1: string;
  FactoryAddress2: string;
  FcmcFee: string;
  GoodsBaseAdmitStatus: string;
};

/**
 * マスタ入力表情報を取得するサービス
 *
 * @export GetMasterInputService
 * @class GetMasterInputService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetMasterInputService extends PlessJsonResponderSub<GetMasterInputResponse> {
  private masterInputId = '';
  private proposalId = '';
  private model: KYMW6901MasterInputTabModel;
  private successFunc: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub,
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetMasterInputService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        MasterInputId: this.masterInputId
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetMasterInputService
   */
  execute(model: KYMW6901MasterInputTabModel, masterInputId: string, proposalId: string, successFunc?: () => void): void {
    this.model = model;
    this.masterInputId = masterInputId;
    this.proposalId = proposalId;
    this.successFunc = successFunc;
    this.send('getMasterInput', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetMasterInputService
   */
  success(data: GetMasterInputResponse): void {
    const result = data;
    this.model.masterInput = new MasterInputModel(
      this.proposalId,
      result.MasterInputId,
      result.PCode,
      result.ItemCode,
      result.JanCode,
      result.GoodsName,
      result.StandardName,
      result.PublishMediumType,
      result.ClassCode,
      result.LargeClassCode,
      result.MiddleClassCode,
      result.SmallClassCode,
      result.OrderUnitType,
      result.SetQuantity,
      result.SuggestedPriceSellingNormal,
      result.SuggestedPriceSellingSpecial1,
      result.SuggestedPriceSellingSpecial2,
      result.SuggestedPricePurchaseNormal,
      result.SuggestedPricePurchaseSpecial1,
      result.SuggestedPricePurchaseSpecial2,
      result.BundlePrice,
      result.UnitPriceDiv,
      result.UnitPriceCoefficient,
      result.UnitPriceUnit,
      result.EdlpDiv,
      result.ConsumeByDate,
      result.ConsumeTerm,
      result.SetDiv,
      result.CaseSupplyDiv,
      result.ArrivalAreaDiv,
      result.ArrivalGoodsTemp,
      result.ArrivalAdminDays,
      result.BrandType,
      result.EcologyDiv,
      result.CycleTerm,
      result.PriceType,
      result.MakerPrice,
      this.model.toCoopMap(result.CoopCode),
      result.PackagePhotographNum,
      result.PackageDataNum,
      result.PeakPhotographNum,
      result.PeakDataNum,
      result.CookingNecessaryPhotoNum,
      result.CookingNecessaryDataNum,
      result.CookingUnnecessaryPhotoNum,
      result.CookingUnnecessaryDataNum,
      result.MaterialPhotographNum,
      result.MaterialDataNum,
      result.BacksidePhotographNum,
      result.BacksideDataNum,
      result.GoodsExplanation,
      result.Catchphrase,
      result.RecommendComment,
      result.UsefulInfoEnclosure,
      result.UsefulInfoConfiguration,
      result.UsefulInfoOther,
      result.UsefulInfoSize,
      result.HandlingCaution,
      {
        markDiv1: result.MarkDiv[0] ?? '',
        markDiv2: result.MarkDiv[1] ?? '',
        markDiv3: result.MarkDiv[2] ?? '',
        markDiv4: result.MarkDiv[3] ?? '',
        markDiv5: result.MarkDiv[4] ?? '',
        markDiv6: result.MarkDiv[5] ?? '',
        markDiv7: result.MarkDiv[6] ?? '',
        markDiv8: result.MarkDiv[7] ?? '',
        markDiv9: result.MarkDiv[8] ?? '',
        markDiv10: result.MarkDiv[9] ?? ''
      },
      result.ConsumeTaxRate,
      result.AlcoholPercentage,
      result.FruitJuice,
      result.SakeMeterValue,
      result.Body,
      result.FunctionalOrFoshu,
      result.LiquorCode,
      result.AlcoholType,
      result.ContainerForm,
      this.toYearDate(result.ApplyTermStart),
      this.toYearDate(result.ApplyTermEnd),
      result.SeasonConsumeDiv === "1",
      this.toDate(result.SeasonConsumeTermStart),
      this.toDate(result.SeasonConsumeTermEnd),
      result.StinkGoodsDiv,
      result.ListingGoodsName,
      result.ListingType,
      result.ListingContentsQuantity,
      result.ListingSize,
      result.ListingSizeCm,
      result.ListingNumber,
      result.ListingColor,
      result.PieceSizeLength,
      result.CaseSizeLength,
      result.PieceSizeWidth,
      result.CaseSizeWidth,
      result.PieceSizeHeight,
      result.CaseSizeHeight,
      result.PieceWeight,
      result.CaseWeight,
      result.IngredientInfo,
      result.IngredientsDisp,
      result.RelationPcodeOld,
      result.SpecialOrderType,
      result.StockType,
      result.PdPilingUpDays,
      result.FactoryAddress1,
      result.FactoryAddress2,
      result.FcmcFee,
      result.GoodsBaseAdmitStatus,
    );

    if (this.successFunc) {
      this.successFunc();
    }
  }

  toYearDate(date) {
    return date === '' ? '' : date.substring(0, 4) + '/' + date.substring(4, 6) + '/' + date.substring(6, 8);
  }

  toDate(date) {
    return date === '' ? '' : date.substring(0, 2) + '/' + date.substring(2, 4);
  }
}
